import React from "react";
import { motion } from "framer-motion";

const TextField = ({ type, name, value, onChange, placeholder, required }) => (
  <motion.div className="mb-4" whileHover={{ scale: 1.03 }}>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full px-4 py-2 border border-gray-300 rounded-md font-body"
      required={required}
    />
  </motion.div>
);

export default TextField;
